import WindowActions from '../actions/windowActions';
import createReducer from '../utils/createReducer';
import {SystemStateRecord, Devices} from '../records/systemStateRecord';
import {determineDevice, determineDeviceSize, getInitialSize} from '../middleware/windowHandler';

function getReviewPageSize(deviceType) {
    const DESKTOP_COUNT = 5;
    const MOBILE_COUNT = 10;

    return deviceType === Devices.mobile ? MOBILE_COUNT : DESKTOP_COUNT;
}

const {height, width} = getInitialSize();

const initialDevice = determineDevice(height, width);
const initialState = new SystemStateRecord({
    device: initialDevice,
    deviceSize: determineDeviceSize(height, width),
    isDesktop: initialDevice === Devices.desktop,
    isMobile: initialDevice === Devices.mobile,
    isTablet: initialDevice === Devices.tablet,
    height,
    reviewPageSize: getReviewPageSize(initialDevice),
    width
});

const actionHandlers = {
    [WindowActions.WINDOW_DEVICE_UPDATED](state, {payload}) {
        const {deviceState, windowSize, device, deviceSize} = payload;

        const newData = state.merge({
            device,
            deviceSize,
            isDesktop: deviceState.isDesktop,
            isMobile: deviceState.isMobile,
            isTablet: deviceState.isTablet,
            height: windowSize.height,
            reviewPageSize: getReviewPageSize(device),
            width: windowSize.width
        });

        return newData;
    },
    [WindowActions.STICKY_POSITION_UPDATED](state, {payload}) {
        const {stickyMap} = payload;
        let newData = state; // Fallback to current state

        try {
            // https://jira.homeawaycorp.com/browse/LISTING-2446
            // On iOS 10 for tablet, there seems to be a problem with immutable maps,
            // ...or something.  Couldn't figure out, but it is legacy.
            const newMap = state.stickyMap.merge(stickyMap);
            newData = state.merge({
                stickyMap: newMap
            });
        } catch (err) {
            // Do nothing.
        }

        return newData;
    }
};

export default createReducer(actionHandlers, initialState);
